import FlatButton from 'material-ui/FlatButton';
import React, {Component} from 'react';
import TextField from 'material-ui/TextField';

import {Centered300} from './container/CenteredContainer';
import {FormRow} from './form/FormElements';
import ErrorMessage from './ErrorMessage';

const background = require('../img/bg_fenster.jpg');
import styled from 'styled-components';
import Grid from 'styled-components-grid';

import cookie from 'react-cookies';
const acceptedCookies = cookie.load('accept_cookies');

const Wrapper = styled.div`
  background: url(${background});
  background-size: cover;
  width: 100%;
  float: left;
  height: auto;
  min-height: 100%;
`;
const LoginBox = styled.div`
  width: 600px;
  margin: 100px auto;
  border: 4px solid ${(props) => props.theme.secondaryColor};
  padding: 30px 15px;
  background: white;
`;
const A = styled.a`
  display: block;
  text-align: right;
`;
const Headline = styled.h1`
  font-size: 24px;
  text-align: left;
`;

const SmallHeadline = styled.h2`
  font-size: 18px;
  text-align: left;
`;
const InfoText = styled.div`
  span {
    font-weight: bold;
  }
  text-align: ${(props) => (props.right ? 'right' : 'left')};
  margin-top: ${(props) => props.marginTop}px;
`;
const ColoredBlock = styled.div`
  background: ${(props) => props.theme.secondaryColor};
  margin: 30px -15px;
  h2 {
    padding-left: 15px;
    padding-top: 15px;
    margin: 0;
  }
`;

class Login extends Component {
  constructor() {
    super();
    this.state = {email: '', password: ''};
  }

  _acceptCookies = () => {
    cookie.save('accept_cookies', 'true');
    window.location.reload();
  };
  _login = () => {
    this.props
      .login(this.state)
      .then(() => this.props.history.replace('/windows'))
      .catch((error) => {
        console.log(error);
        this.setState({errors: [error]});
      });
  };
  _getUser = () => {
    window.location = 'mailto:tischler@wko.at';
  };
  render() {
    return (
      <Wrapper>
        <LoginBox>
          <ErrorMessage errors={this.state.errors} />
          <Headline>Herzlich willkommen auf der neuen Serviceplattform für Tischler!</Headline>
          <InfoText>
            Die neue Serviceleistung der Bundesinnung der Tischler und Holzgestalter betreffend CE-Kennzeichnung für
            Fenster.
            <br />
            Das Herzstück bildet eine neue Datenbank, die alle jene Informationen über Fensterkonstruktionen enthält,
            die den harmonisierten Normen entsprechen. Betriebe haben so die Möglichkeit aus den angebotenen Daten
            entsprechende Konstruktionen auszuwählen und 1:1 nachzubauen. Umfangreiche Prüfungen im Rahmen der
            CE-Kennzeichnung entfallen, da die Konstruktionen aus der Datenbank für den Fensterbau übernommen werden
            können und dabei volle Rechtssicherheit besteht.
          </InfoText>

          {acceptedCookies ? (
            <ColoredBlock>
              <SmallHeadline>Login</SmallHeadline>
              <Centered300>
                <FormRow>
                  <TextField
                    autoComplete={false}
                    hintText='Email'
                    value={this.state.email}
                    onChange={(event) => {
                      this.setState({email: event.target.value});
                    }}
                    onKeyPress={(event) => {
                      if (event.key === 'Enter') {
                        this._login();
                      }
                    }}
                  />
                </FormRow>
                <FormRow>
                  <TextField
                    autoComplete={false}
                    hintText='Passwort'
                    type='password'
                    value={this.state.password}
                    onChange={(event) => {
                      this.setState({password: event.target.value});
                    }}
                    onKeyPress={(event) => {
                      if (event.key === 'Enter') {
                        this._login();
                      }
                    }}
                  />
                </FormRow>
                <FormRow>
                  <FlatButton primary={true} onClick={this._login}>
                    Anmelden
                  </FlatButton>
                  <FlatButton primary={true} onClick={this._getUser} style={{paddingLeft: 10, paddingRight: 10}}>
                    Benutzer anfordern
                  </FlatButton>
                </FormRow>
              </Centered300>
            </ColoredBlock>
          ) : (
            <ColoredBlock>
              <SmallHeadline>Tischlerfenster.at verwendet Cookies zur Analyse!</SmallHeadline>
              <FormRow>
                <FlatButton primary={true} onClick={this._acceptCookies}>
                  Cookies akzeptieren
                </FlatButton>
                <FlatButton
                  primary={true}
                  onClick={() => (window.location.href = '/#/datenschutz')}
                  style={{paddingLeft: 10, paddingRight: 10}}>
                  Datenschutzbestimmungen
                </FlatButton>
              </FormRow>
            </ColoredBlock>
          )}
          <SmallHeadline>Für Inhalt verantwortlich:</SmallHeadline>
          <Grid>
            <Grid.Unit size={0.5}>
              <InfoText>
                <span>BIM KommR. Gerhard Spitzbart</span>
                <br />
                Bundesinnungsmeister
              </InfoText>
            </Grid.Unit>
            <Grid.Unit size={0.5}>
              <InfoText right>
                <span>Mag. (FH) Dieter Jank</span>
                <br />
                Geschäftsführer
              </InfoText>
            </Grid.Unit>
          </Grid>

          <InfoText marginTop={40}>
            Bundesinnung der Tischler und Holzgestalter
            <br />
            Wirtschaftskammer Österreich
            <br />
            Wiedner Hauptstraße 63 | 1045 Wien
            <br />
            <span>T</span> 05 90 900-3234 | <span>F</span> 05 90 900-113234
            <br />
            <span>E</span> tischler@wko.at | <span>W</span> www.tischler.at
            <br />
            Bildquelle: Tischlerei Lohninger
            <br />
            <A href='/#/Datenschutz'>Datenschutzbestimmungen</A>
          </InfoText>
        </LoginBox>
      </Wrapper>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login.js